import axios from 'axios'
import { hex_md5 } from 'react-native-md5'

const api = axios.create({
    baseURL: '/api',
    //baseURL: 'http://localhost/sales',
})
const setAppAuthHeaders = (appAuthParams) => {
    api.defaults.headers.post['request-app-id'] = appAuthParams.appid
    api.defaults.headers.post['request-app-token'] = appAuthParams.apptoken
    api.defaults.headers.post['request-app-time'] = appAuthParams.apptime
    api.defaults.headers.post['request-app-from'] = appAuthParams.appfrom
}
const setHeader = (k, v) => {
    api.defaults.headers.post[k] = v
    api.defaults.headers.get[k] = v
    api.defaults.headers.put[k] = v
    api.defaults.headers.delete[k] = v
}
const getAppAUthHeadersConfig = (appAuthParams) => {
    return {
        headers: {
            'request-app-id': appAuthParams.appid,
            'request-app-token': appAuthParams.apptoken,
            'request-app-time': appAuthParams.apptime,
            'request-app-from': appAuthParams.appfrom,
        }
    }

}
const signIn = (userInfo, headers) => api.post(`/user/login`, userInfo, headers)
const signOut = (headers)=>api.get(`/user/signout`,headers)
const signUp = (userInfo, headers) => api.post(`/user/register`, userInfo, headers)
const sendCode = (data,headers) =>api.post(`/user/sendcode`,data,headers)
const sendCode1 = (data,headers) =>api.post(`/user/sendcode1`,data,headers)
const resetPwd = (data,headers) => api.post(`/user/resetpwd`,data,headers)
const emailVerify = (data,headers) => api.post(`/user/verifycode`,data,headers)
const loadUseProfile = (headers)=>api.get(`/user/profile`,headers)
const modifyUserProfile = (data,headers)=>api.post(`/user/profile`,data,headers)
const queryParams = (params)=>{
    let keys = Object.keys(params)
    let p = "?_params="+keys.length
    for(let k of keys) {
        p = p + '&' + k + '='+params[k]
    }
    return p
}
const formatUrl = (url,params)=>{
    let i =0
    
    Object.keys(params).forEach((k)=> {
        if(params[k] != undefined) {        
            if(i==0) {
                url+="?"+k+"="+params[k]
            }else {
                url+="&"+k+"="+params[k]
            }
            i++
        }
    })
    return url
}
const apis = {
    signIn,
    signOut,
    signUp,
    resetPwd,
    sendCode,sendCode1,
    emailVerify,
    loadUseProfile,
    setHeader,
    modifyUserProfile,
    coachSignIn:(userInfo,headers)=>api.post(`/user/coachlogin`,userInfo,headers),
    //system
    loginLoad:(headers)=>api.get(`/service/loginload?time=`+Date.now(),headers),
    applyService:(appid,headers)=>api.post(`/service/applyservice`,{appid:appid},headers),
    loadServices:(headers)=>api.get(`/service/services`,headers),
    loadDashBoard:(headers)=>api.get(`/service/dashboard`,headers),
    
    //crm
    crmLoad:(headers)=>api.get(`/member/loginload`,headers),
    loadCustomer:(page,pagesize,countdata,showOption,orderfield,order,headers)=>api.get(`/member/loadcustomer?status=`+showOption+`&orderfield=`+orderfield+`&order=`+order+`&countdata=`+countdata+`&page=`+page+`&pagesize=`+pagesize+`&time=`+Date.now(),headers),
    loadUser:(page,pagesize,countdata,showOption,orderfield,order,headers)=>api.get(`/member/loaduser?status=`+showOption+`&countdata=`+countdata+`&page=`+page+`&pagesize=`+pagesize+`&orderfield=`+orderfield+`&order=`+order+`&time=`+Date.now(),headers),
    editCustomer:(data,headers)=>api.post(`/member/editcustomer`,data,headers),
    editUser:(data,headers)=>api.post(`/member/edituser`,data,headers),
    getCustomer:(id,headers)=>api.get(`/member/getcustomer?id=`+id,headers),
    customerSearch:(data,page,rows,countdata,showOption,headers)=>api.get(`/member/searchcustomer?status=`+showOption+`&value=`+encodeURIComponent(data) + '&page='+page+'&pagesize='+rows+'&countdata='+countdata+`&time=`+Date.now(),headers),
    userSearch:(data,page,rows,countdata,showOption,headers)=>api.get(`/member/searchuser?status=`+showOption+`&value=`+encodeURIComponent(data) + '&page='+page+'&pagesize='+rows+'&countdata='+countdata+`&time=`+Date.now(),headers),
    loadMemberInfoStruct:(headers)=>api.get(`/member/getmemberinfostruct`,headers),
    setMemberInfoStruct:(data,headers)=>api.post(`/member/setmemberinfostruct`,data,headers),
    changeMemberStatus:(id,status,headers)=>api.post(`/member/changememberstatus`,{id:id,status:status},headers),
    changeMemberLevel:(id,level,headers)=>api.post(`/member/changememberlevel`,{id:id,level:level},headers),
    changeUserStatus:(id,status,headers)=>api.post(`/member/changeuserstatus`,{id:id,status:status},headers),
    //member
    loadFamilys:(page,pagesize,countdata,field,order,value,headers)=>{
        field = field?field:'id'
        order = order?order:'desc'
        if(!value) {
            return api.get(`/member/loadfamilys?countdata=`+countdata+`&page=`+page+`&pagesize=`+pagesize+'&orderfield='+field + '&order=' + order +`&time=`+Date.now(),headers)
        }else {
            return api.get(`/member/loadfamilys?countdata=`+countdata+`&page=`+page+`&pagesize=`+pagesize+'&orderfield='+field + '&order=' + order +`&time=`+Date.now()+`&value=`+value,headers)
        }
        
    },    
    loadParent:(id,headers)=>api.get("/member/parent?id="+id,headers),
    loadMembers:(page,pagesize,countdata,headers)=>api.get(`/member/loadmembers?countdata=`+countdata+`&page=`+page+`&pagesize=`+pagesize+`&time=`+Date.now(),headers),    
    balancelog:(fid,mid,page,size,countdata,begin,end,action,headers) => api.get(`/member/balancelog?user_id=`+fid+`&member_id=`+mid+`&countdata=`+countdata+`&page=`+page+`&size=`+size+`&begin=`+begin+`&end=`+end+`&action=`+action+`&time=`+Date.now(),headers),
    getBalance:(userid,memberid,headers)=>api.get(`/member/balance?user_id=`+userid+`&member_id=`+memberid,headers),
    updateBalance:(data,headers)=>api.put(`/member/balance`,data,headers),
    
    //merchant
    userMerchant:(headers)=>api.get(`/merchant/merchant?time=`+Date.now(),headers),
    merchantPwd:(headers)=>api.get(`/merchant/merchantpwd?time=`+Date.now(),headers),
    addCompany:(data,headers)=>api.post(`/merchant/addcompany`,data,headers),
    joinCompany:(data,headers)=>api.post(`/merchant/joincompany`,data,headers),
    
    //coach
    loadCoaches:(headers)=>api.get(`/coach/loadcoaches`,headers),
    editCoach:(data,headers)=>api.post(`/coach/coach`,data,headers),
    removeCoach:(id,headers)=>api.get(`/coach/remove?id=`+id,headers),
    loadCoachRecord:(id,from,to,headers)=>api.get(`/coach/loadcoachrecord?id=`+id+'&from='+from+'&to='+to,headers),
    loadCoachTime:(id,page,pagesize,countdata,headers) =>api.get(`/coach/loadcoachtime?id=`+id+`&page=`+page+'&pagesize='+pagesize+'&countdata='+countdata+`&time=`+Date.now(),headers),
    teachlog:(id,page,size,countdata,begin,end,headers)=>api.get('/coach/lessonlog'+queryParams({id,page,size,countdata,begin,end}),headers),
    teachlogUpdate:(data,headers)=>api.put('/coach/lessonlog',data,headers),
    //email
    emailModuleLoad:(headers)=>api.get(`/email/loginload`,headers),
    loadTemplates:(page,pagesize,countdata,headers) =>api.get(`/email/loadtemplates?page=`+page+'&pagesize='+pagesize+'&countdata='+countdata+`&time=`+Date.now(),headers),
    getTemplate:(id,headers)=>api.get( `/email/gettemplate?id=`+id,headers),
    editTemplate:(data,headers) => api.post(`/email/edittemplate`,data,headers),
    removeTemplate:(data,headers)=>api.post(`/email/removetemplate`,data,headers),
    cloneTemplate:(data,headers)=>api.post(`/email/clonetemplate`,data,headers),
    editEmailTask:(data,headers)=>api.post(`/email/edittask`,data,headers),
    loadEmailTasks:(page,pagesize,countdata,headers) =>api.get(`/email/loadtasks?page=`+page+'&pagesize='+pagesize+'&countdata='+countdata+`&time=`+Date.now(),headers),
    getEmailTask:(id,headers)=>api.get( `/email/gettask?id=`+id,headers), 
    setTaskStatus:(id,status,headers)=>api.post(`/email/settaskstatus`,{id:id,status:status},headers),           
    loadHouse:(id,headers)=>api.get(`/email/gethouse?id=`+id,headers),
    loadTaskResult:(id,headers)=>api.get(`/email/loadtaskresult?id=`+id,headers),
    //event
    eventMenuLoad:(headers)=>api.get(`/event/loginload`,headers),
    loadEvents:(page,pagesize,countdata,headers) =>api.get(`/event/loadevents?page=`+page+'&pagesize='+pagesize+'&countdata='+countdata+`&time=`+Date.now(),headers),
    getEvent:(id,headers)=>api.get( `/event/getevent?id=`+id,headers),
    editEvent:(data,headers) => api.post(`/event/editevent`,data,headers),
    removeEvent:(data,headers)=>api.post(`/event/removeevent`,data,headers),
    cloneEvent:(data,headers)=>api.post(`/event/cloneevent`,data,headers),
    setEventStatus:(id,status,headers)=>api.post(`/event/setstatus`,{id:id,status:status},headers),
    setEventPublishStatus:(id,status,headers)=>api.post(`/event/setpublishstatus`,{id:id,status:status},headers),
    loadApplicants:(id,page,size,countdata,headers) =>api.get(`/event/loadapplicants?id=`+id+`&page=`+page+'&pagesize='+size+'&countdata='+countdata+`&time=`+Date.now(),headers),

    //resource
    uploadResource:(session)=>{
        let time = Date.now()
        return {
            url:'/api/resource/upload',
            headers:{
                'request-userid':session.userid,
                'request-appid':0,
                'request-token':hex_md5(session.token+time),
                'request-time':time
            }
        }},
    loadResources:(type,page,pagesize,countdata,headers) => api.get(`/resource/loadresources?type=`+type+`&page=`+page+'&pagesize='+pagesize+'&countdata='+countdata+`&time=`+Date.now(),headers),
    postResource:(data,headers)=>api.post('/resource/postresource',data,headers),
    resourceStatus:(id,status,headers)=>api.post('/resource/changestatus',{id:id,status:status},headers),

    //setting
    userPost:(data,headers)=>api.post('/setting/user',data,headers),
    userGet:(id,headers)=>api.get('/setting/user?id='+id,headers),
    userDelete:(id,headers)=>api.delete('/setting/user?id='+id,headers),
    userPut:(data,headers) => api.put('/setting/user',data,headers),
    
    menuPost:(data,headers)=>api.post('/setting/menu',data,headers),
    menuGet:(id,headers)=>api.get('/setting/menu?id='+id,headers),
    menuDelete:(id,headers)=>api.delete('/setting/menu?id='+id,headers),
    menuPut:(data,headers) => api.put('/setting/menu',data,headers),

    rolePost:(data,headers)=>api.post('/setting/role',data,headers),
    roleGet:(id,headers)=>api.get('/setting/role?id='+id,headers),
    roleDelete:(id,headers)=>api.delete('/setting/role?id='+id,headers),
    rolePut:(data,headers) => api.put('/setting/role',data,headers),
    
    userrolePost:(data,headers)=>api.post('/setting/userrole',data,headers),
    userroleGet:(user_id,headers)=>api.get('/setting/userrole?user_id='+user_id,headers),
    roleuserGet:(role_id,headers)=>api.get('/setting/userrole?role_id='+role_id,headers),
    userroleDelete:(id,headers)=>api.delete('/setting/userrole?id='+id,headers),
    userrolePut:(data,headers) => api.put('/setting/userrole',data,headers),
    
    roleauthPost:(data,headers)=>api.post('/setting/roleauth',data,headers),
    roleauthGet:(id,headers)=>api.get('/setting/roleauth?id='+id,headers),
    roleauthDelete:(id,headers)=>api.delete('/setting/roleauth?id='+id,headers),
    roleauthPut:(data,headers) => api.put('/setting/roleauth',data,headers),
    
    balancePost:(data,headers)=>api.post('/setting/balance',data,headers),
    balanceGet:(id,headers)=>api.get('/setting/balance?id='+id,headers),
    balanceDelete:(id,headers)=>api.delete('/setting/balance?id='+id,headers),
    balancePut:(data,headers) => api.put('/setting/balance',data,headers),

    areaPost:(data,headers)=>api.post('/setting/area',data,headers),
    areaGet:(id,headers)=>api.get('/setting/area?id='+id,headers),
    areaDelete:(id,headers)=>api.delete('/setting/area?id='+id,headers),
    areaPut:(data,headers) => api.put('/setting/area',data,headers),

    settingPost:(item,data,headers)=>api.post('/setting/'+item,data,headers),
    settingGet:(item,id,status,headers)=>api.get(formatUrl('/setting/'+item,{id,status}),headers),
    settingDelete:(item,id,headers)=>api.delete(formatUrl('/setting/'+item,{id}),headers),
    settingPut:(item,data,headers) => api.put('/setting/'+item,data,headers),

    classroomPost:(data,headers)=>api.post('/setting/classroom',data,headers),
    classroomGet:(id,status,headers)=>api.get(formatUrl('/setting/classroom',{id,status}),headers),
    classroomDelete:(id,headers)=>api.delete('/setting/classroom?id='+id,headers),
    classroomPut:(data,headers) => api.put('/setting/classroom',data,headers),
    
    holidayPost:(data,headers)=>api.post('/setting/holiday',data,headers),
    holidayGet:(year,month,headers)=>api.get('/setting/holiday?year='+year+(month?('&month='+month):''),headers),
    holidayDelete:(id,headers)=>api.delete('/setting/holiday?id='+id,headers),
    holidayPut:(data,headers) => api.put('/setting/holiday',data,headers),

    courses:(status,headers)=>{return status >= 0?api.get('/course/courses?status='+status,headers):api.get('/course/courses',headers)},
    courseGet:(id,lesson,headers)=>api.get('/course/course?id='+id+(lesson?('&lesson='+lesson):''),headers),
    coursePost:(data,headers)=>api.post('/course/course',data,headers),
    coursePut:(data,headers)=>api.put('/course/course',data,headers),
    courseDelete:(id,headers)=>api.delete('/course/course?id='+id,headers),
    courseMembersGet:(category_id,course_id,headers) => api.get(formatUrl('/course/members',{category_id,course_id}),headers),
    courseRecordsGet:(category_id,year,month,headers) => api.get(formatUrl('/course/records',{category_id,year,month}),headers),
    

    lessonGet:(id,content,headers)=>api.get('/course/lesson?id='+id+(content?('&content='+content):''),headers),
    lessonPost:(data,headers)=>api.post('/course/lesson',data,headers),
    lessonPut:(data,headers)=>api.put('/course/lesson',data,headers),
    lessonDelete:(id,headers)=>api.delete('/course/lesson?id='+id,headers),
    
    lessonpageGet:(id,headers)=>api.get(formatUrl('/course/lessonpage',{id}),headers),
    lessonpagePost:(data,headers)=>api.post('/course/lessonpage',data,headers),
    lessonpagePut:(data,headers)=>api.put('/course/lessonpage',data,headers),
    lessonpageDelete:(id,headers)=>api.delete('/course/lessonpage?id='+id,headers),
    // class
    
    classNewGet:(id,ccid,headers)=>api.get('/website/classnew?id='+id+"&ccid="+ccid,headers),
    classNewPost:(data,headers)=>api.post('/website/classnew',data,headers),
    classNewPut:(data,headers)=>api.put('/website/classnew',data,headers),
    classNewDelete:(id,headers)=>api.delete("/website/classnew?id="+id,headers),
    categoryCourseGet:(headers)=>api.get("/course/categorycourse",headers),
    
    courseCategoryGet:(id,simple,headers)=>api.get('/course/coursecategory?id='+id+(simple == 1?"&simple=1":""),headers),
    courseCategoryPost:(data,headers)=>api.post('/course/coursecategory',data,headers),
    courseCategoryPut:(data,headers)=>api.put('/course/coursecategory',data,headers),
    courseCategoryDelete:(id,headers)=>api.delete('/course/coursecategory?id='+id,headers),

    coursepackageGet:(category_id,status,headers)=>api.get(formatUrl("/course/coursepackage",{category_id,status}),headers),
    coursepackagePost:(data,headers)=>api.post("/course/coursepackage",data,headers),
    coursepackagePut:(data,headers)=>api.put("/course/coursepackage",data,headers),
    coursepackageDelete:(id,remove,headers)=>api.delete(formatUrl("/course/coursepackage",{id,remove}),headers),
    //load catetory course tree
    loadCategoryCourses:(headers)=>api.get("/course/categorycourses",headers),
    
    membercourseGet:(category_id,course_package_id,member_id,page,headers)=>api.get(formatUrl("/member/membercourse",{category_id,member_id,course_package_id,page}),headers),
    membercoursePost:(member_id,course_package_id,headers)=>api.post("/member/membercourse",{member_id,course_package_id},headers),
    membercoursePut:(id,status,headers)=>api.put("/member/membercourse",{id,status},headers),
    membercourseDelete:(id,headers)=>api.delete("/member/membercourse?id="+id,headers),

    memberCourseRecordLoad:(id,headers)=>api.get(formatUrl("/member/membercourserecords",{id},headers)),
    membersCourseRecordGet:(id,headers) => api.get(formatUrl('/member/membercourserecord',{id}),headers),
    membersCourseRecordPost:(data,headers)=>api.post("/member/membercourserecord",data,headers),
    membersCourseRecordPut:(data,headers)=>api.put("/member/membercourserecord",data,headers),
    membersCourseRecordSettle:(data,headers)=>api.put("/member/membercourserecord",data,headers),

    membercourseorderRefund:(data,headers)=>api.put("/member/membercourseorder",data,headers),
    membercourseorderGet:(member_id,course_package_id,headers)=>api.get(formatUrl("/member/membercourseorder",{member_id,course_package_id}),headers),
    membercourseRecharge:(member_id,course_package_id,amount,price,headers)=>api.post("/member/membercourseorder",{member_id,course_package_id,amount,price},headers),
    
    
    classApplicantGet:(id,ccid,headers) =>api.get('/website/classapplicant?id='+id+"&ccid="+ccid,headers),
    classApplicantPut:(data,headers) => api.put('/website/classapplicant',data,headers),
    classes:(status,category_id,week_date,headers)=>api.get(formatUrl("/class/classes",{status,category_id,week_date}),headers),
    classGet:(id,headers)=>api.get('/class/class?id='+id,headers),
    classPost:(data,headers)=>api.post('/class/class',data,headers),
    classPut:(data,headers)=>api.put('/class/class',data,headers),
    classDelete:(id,headers)=>api.delete('/class/class?id='+id,headers),
    classmembers:(classid,status,headers)=>api.get(formatUrl('/class/classmembers',{classid,status}),headers),
    classmemberPost:(data,headers) => api.post('/class/classmember',data,headers),
    classmemberPut:(data,headers) => api.put('/class/classmember',data,headers),
    classmemberDelete:(id,headers) => api.delete('/class/classmember?id='+id,headers),    
    teacherCheckin:(scheduleid,coachid,headers)=>api.post('/class/teachercheckin',{scheduleid,coachid},headers),    
    
    //report
    monthReport:(from,to,headers)=>api.get(formatUrl('/report/monthreport',{from,to}),headers),
}

export default apis
